import React from 'react';

/**
 * Barre d'avancement d'une tâche.
 *
 * Elle n'avance qu'aux étapes réellement franchies, rapportées par le backend : pas
 * d'animation qui progresserait toute seule pendant qu'une passe de correction piétine.
 * Tant qu'aucune étape n'a été signalée, la barre reste indéterminée — c'est plus
 * honnête que d'afficher un pourcentage inventé.
 *
 * @param {number} value  avancement de 0 à 100
 * @param {string} step   ce qui se passe, en clair
 * @param {boolean} compact  version réduite pour le panneau flottant
 */
export default function JobProgress({ value = 0, step = '', compact = false }) {
  const pct = Math.max(0, Math.min(100, Math.round(Number(value) || 0)));
  const unknown = pct <= 0;

  return (
    <div className={`job-progress ${compact ? 'compact' : ''}`}>
      <div
        className={`job-progress-track ${unknown ? 'indeterminate' : ''}`}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={unknown ? undefined : pct}
        aria-valuetext={step || (unknown ? 'Démarrage…' : `${pct} %`)}
        aria-label="Avancement de la tâche"
      >
        <div className="job-progress-fill" style={unknown ? undefined : { width: `${pct}%` }} />
      </div>
      {!compact && (
        <div className="job-progress-meta">
          <span className="job-progress-step">{step || 'Démarrage…'}</span>
          {!unknown && <span className="job-progress-pct">{pct} %</span>}
        </div>
      )}
    </div>
  );
}
